import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { YearSelector } from '../../components/YearSelector';
import { SubscriptionsChart } from './cards/SubscriptionsChart';
import { RegistrationsChart } from './cards/RegistrationsChart';

const StyledTab = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

/**
 * Component to display statistics using subscription and registration charts.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.customerInvoices - Customer invoices data.
 * @param {Object} props.registrations - Registrations data.
 *
 * @returns {React.ReactNode} - The rendered component.
 */
export const ShowStatistics = ({
  customerInvoices,
  registrations,
  setStatisticsDate,
  subscriptions,
  statisticsDate
}) => {
  const { t } = useTranslation();

  return (
    <StyledTab>
      <YearSelector onChange={setStatisticsDate} />
      <SubscriptionsChart
        t={t}
        customerInvoices={customerInvoices}
        subscriptions={subscriptions}
        statisticsDate={statisticsDate}
      />
      <RegistrationsChart t={t} registrations={registrations} />
    </StyledTab>
  );
};

ShowStatistics.propTypes = {
  customerInvoices: PropTypes.shape({}).isRequired,
  subscriptions: PropTypes.shape({}).isRequired,
  registrations: PropTypes.shape({}).isRequired,
  setStatisticsDate: PropTypes.func.isRequired,
  statisticsDate: PropTypes.string
};

ShowStatistics.defaultProps = {
  statisticsDate: null
};
